import { Reward } from '@/app/api';
import Dialog from '@/app/components/Dialog/Dialog';
import RewardBox, { RewardBoxStyle } from '@/app/components/RewardBox/RewardBox';
import { Routes } from '@/app/enums';
import { useIsProjectActive } from '@/app/providers/ProjectProvider';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type RewardsSideBarProps = {
  rewards: Reward[];
  className?: string;
  numericId: number;
};

export const RewardsSideBar = ({ rewards, numericId }: RewardsSideBarProps) => {
  const pathName = useMemo<string>(() => `/${Routes.DONATION}/${numericId}`, [numericId]);
  const { t } = useTranslation();
  const isProjectActive = useIsProjectActive();

  return (
    <>
      <h2 className="text-center text-[24px] leading-[32px] lg:text-[32px] font-medium lg:leading-[40px] text-balance mb-[26px]">
        {t('pages.collection.pickReward')}
      </h2>
      {rewards.map((reward) => (
        <RewardBox
          shouldHideControlButtons={!isProjectActive}
          isImageAlwaysVisible={false}
          idPrefix="pick"
          key={reward.id}
          reward={reward}
          selectLinkPathname={pathName}
          defaultIsOpen={false}
          style={RewardBoxStyle.COMPACT}
          onSelectReward={() => {}}
          isVariantSelectVisible
          selectedVariant={undefined}
        />
      ))}
    </>
  );
};

export const RewardsMobileWidget = ({ rewards, className, numericId }: RewardsSideBarProps) => {
  const [selectedReward, setSelectedReward] = useState<Reward | undefined>(undefined);
  const pathName = useMemo<string>(() => `/${Routes.DONATION}/${numericId}`, [numericId]);
  const isProjectActive = useIsProjectActive();

  return (
    <div className={classNames('w-[360px]', className)}>
      <Dialog isOpen={!!selectedReward} onClose={() => setSelectedReward(undefined)}>
        <div className="px-[4px] py-[32px]">
          {selectedReward && (
            <RewardBox
              shouldHideControlButtons={!isProjectActive}
              onClickHandler={() => null}
              isImageAlwaysVisible
              idPrefix="pick"
              defaultIsOpen
              reward={selectedReward}
              selectLinkPathname={pathName}
              style={RewardBoxStyle.COLUMNS}
              isVariantSelectVisible
              selectedVariant={undefined}
              isFullScreenDisplay
            />
          )}
        </div>
      </Dialog>

      <div className="py-[24px] w-[100vw]  flex flex-row gap-[16px] overflow-x-scroll snap-x snap-mandatory scroll-smooth">
        {rewards.map((reward, index) => (
          <div
            key={reward.id}
            className={classNames(
              'snap-center flex',
              index === 0 && 'ml-[10vw]',
              index === rewards.length - 1 && 'mr-[10vw]',
            )}
          >
            <div className="w-[80vw] flex">
              <RewardBox
                shouldHideControlButtons={!isProjectActive}
                onClickHandler={() => setSelectedReward(reward)}
                className="w-[100%] snap-center"
                isImageAlwaysVisible
                idPrefix="pick"
                reward={reward}
                selectLinkPathname={pathName}
                style={RewardBoxStyle.COMPACT}
                onSelectReward={() => {
                  setSelectedReward(reward);
                }}
                isVariantSelectVisible
                selectedVariant={undefined}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
